import script from "./ContactView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=ts"

import "./ContactView.vue?vue&type=style&index=0&id=1686c686&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1686c686"]])

export default __exports__